export const SearchInput=(props)=>{
    return(
        <>
        <input className={props.className} onChange={props.onchange}  defaultValue={props.defaultValue}  onSubmit={props.onSubmit} value={props.value} placeholder={props.placeholder || "Search..."}/>
        </>
    )
}